import { ServerError } from '@/types/errors/server.error';

export const CUE_ITEM_NOT_ON_LIVE_SHEET_MESSAGE = 'Cue item is not on the live sheet';

export function isCueItemNotOnLiveSheetError(error: unknown): boolean {
  if (!(error instanceof ServerError) || error.statusCode !== 404) {
    return false;
  }
  return error.message.includes(CUE_ITEM_NOT_ON_LIVE_SHEET_MESSAGE);
}
